'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = isOK;

var _constants = require('../constants');

var _isState = require('./is-state');

var _isState2 = _interopRequireDefault(_isState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFilledEntry(e) {
    var hasId = e.id !== null && typeof e.id !== 'undefined';
    var hasData = e.id !== null && typeof e.data !== 'undefined';

    // dangerous, might need to add types as object metadata later
    var isList = Array.isArray(e.entries) && (0, _typeof3.default)(e.state) === 'symbol';

    return hasId || hasData || isList;
}

var stateOK = function stateOK(e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return r && (0, _isState2.default)(e, _constants.OK) && isFilledEntry(e);
};
var stateLOADING = function stateLOADING(e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if ((0, _isState2.default)(e, _constants.LOADING) && isFilledEntry(e)) return true;

    return r;
};

function isOK(resource) {
    if ((0, _isState2.default)(resource, stateOK)) return true;

    if ((0, _isState2.default)(resource, stateLOADING)) return true;

    return false;
}